export default __webpack_public_path__ + "static/media/infoWhite.71984ce0.svg";